const TOKEN_MIN_EXP_TIME = 300;
export const parseJWT = (token) => {
    return JSON.parse(b64DecodeUnicode(token.split('.')[1]));
};
export const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); // eslint-disable-line
    }).join(''));
};
/**
 * Takes token expiring time and return true if it has expired
 * */
export const checkTokenExpire = (tokenExpTime) => {
    let isTokenExpire = true;
    // get current time and round it to seconds
    const currentTime = new Date().getTime() / 1000; // eslint-disable-line
    const roundedTime = Math.round(currentTime);
    const diff = tokenExpTime - roundedTime;
    if (diff > TOKEN_MIN_EXP_TIME) {
        isTokenExpire = false;
    }
    return isTokenExpire;
};
export const getTimeToRefresh = (tokenExpTime) => {
    // get current time and round it to seconds
    const currentTime = new Date().getTime() / 1000; // eslint-disable-line
    const roundedTime = Math.round(currentTime);
    return (tokenExpTime - roundedTime - TOKEN_MIN_EXP_TIME) * 1000; // eslint-disable-line
};
